import React, { useEffect, useState } from "react";
import {
  FINANCE_HOSTNAME,
  INVOICE_TRACKING_HOSTNAME
} from "../../../../common-utilities/utils/end-points";
import { HTTP_METHODS, invokeApi } from "../../../utils/http-service";
import { getHeaderConfig } from "./helper";
import "./index.scss";
import MuiTable from "../../../../common-utilities/core/mui-table";
import { FINANCE_REST_URLS } from "../../../../common-utilities/utils/end-points/finance";
import { useNavigate } from "react-router-dom";
import { Button, TextField } from "@mui/material";
import { downloadReports } from "./utils";
import { toast } from "react-toastify";
import ConfirmApprove from "./confirm-approve";
import { REST_URLS } from "../../../../common-utilities/utils/end-points/invoice-tracking";
const DocumentList = ({ stage, role }) => {
  const navigate = useNavigate();
  const [bulkSelectIds, setBulkSelectIds] = useState([]);
  const [budgetList, setBudgetList] = useState({});
  const [searchKey, setSearchKey] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);
  const [approvedPODetails, setApprovedPODetails] = useState({});
  const [filters, setFilters] = useState({
    limit: 10,
    page: 1,
    sortBy: "-createdAt"
  });

  useEffect(() => {
    if (stage) {
      loadData(filters);
    }
  }, [stage]);

  const loadData = (apiFilters, download) => {
    let params = {
      ...apiFilters
    };

    if (searchKey) {
      params.searchKey = searchKey;
    }
    if (stage === "openOrPending") {
      params.openOrPending = true;
    } else if (stage === "pendingWithRole") {
      params.pendingWithRole = role;
    } else if (stage !== "all") {
      params.stage = stage;
    }


    invokeApi(
      HTTP_METHODS.GET,
      `${INVOICE_TRACKING_HOSTNAME}${REST_URLS.LEGAL_DOCUMENT}`,
      null,
      params
    )
      .then((response) => {
        if (download) {
          downloadReports(response || [], stage);
          return;
        }
        setBudgetList(response);
        setApprovedPODetails({
          totalResults: response.totalResults,
          totalSum: Math.round(response.totalSum)
        });
      })
      .catch((err) => { });
  };

  const viewBudget = (data, type) => {
    if (type === "EDIT") {
      navigate(`legal-document-details/edit/${data.id}`);
    } else {
      navigate(`legal-document-details/${data.id}`);
    }
  };

  const onApprove = () => {
    let payload = { id: bulkSelectIds };
    setShowConfirm(true);
    if (bulkSelectIds.includes("all")) {
      payload.approveAll = true;
    }

    invokeApi(
      HTTP_METHODS.POST,
      `${FINANCE_HOSTNAME}${FINANCE_REST_URLS.SMALLWARE_PO}approve`,
      payload
    )
      .then((response) => {
        if (response.code) {
          toast.error(response.message || "Failed to approve");
        } else {
          loadData(filters);
          setShowConfirm(false);
          setBulkSelectIds([]);
        }
      })
      .catch((err) => {
        toast.error("Failed to approve");
      });
  };

  return (
    <div className='po-list'>
      <div className='filter-row'>
        <TextField
          placeholder='Search'
          value={searchKey}
          size='small'
          onChange={(e) => setSearchKey(e.target.value)}
        />
        <Button
          variant='outlined'
          onClick={() => {
            setFilters({
              ...filters,
              page: 1
            });
            loadData({
              ...filters,
              page: 1
            });
          }}
        >
          Search
        </Button>
      </div>
      <div className='end-btns'></div>

      <MuiTable
        columnsList={getHeaderConfig(
          viewBudget,
          filters,
          setFilters,
          stage,
          loadData,
          bulkSelectIds,
          setBulkSelectIds
        )}
        dataList={budgetList.results || []}
        filters={filters}
        pageCount={budgetList.totalPages}
        onChange={(page) => {
          setFilters({
            ...filters,
            page
          });
          loadData({
            ...filters,
            page
          });
        }}
      />
      {showConfirm && (
        <ConfirmApprove
          bulkApprove={onApprove}
          approvedPODetails={approvedPODetails}
          setIsConfirmModalOpen={setShowConfirm}
        />
      )}
    </div>
  );
};

export default DocumentList;
